module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/partner3-cd81e2f3f2157efa94b4160c2f76404a.png";